<nz-space class="mobile-report-control">
  <app-stock-account-presets-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
    valueField="code" [allowClear]="this.canClear">
  </app-stock-account-presets-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-stock-account-presets-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)"
    valueField="code" [allowClear]="this.canClear"></app-stock-account-presets-select>
</nz-space>
